/**
 * This file is part of CNT: Sindicats.
 *
 * CNT: Sindicats is free software: you can redistribute it and/or modify it
 * under the terms of the GNU General Public License as published by the Free
 * Software Foundation, either version 2 of the License, or any later version.
 *
 * CNT: Sindicats is distributed in the hope that it will be useful, but
 * WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY
 * or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License for
 * more details.
 *
 * You should have received a copy of the GNU General Public License along with
 * CNT: Sindicats.  If not, see <https://www.gnu.org/licenses/>.
 */
import { createElement, render } from "@wordpress/element";
import 'leaflet/dist/leaflet.css';
import './map-view.scss';
import SyndicateMap from "./SyndicateMap";

function ready( fn ) {
	if ( document.readyState !== 'loading' ) {
		fn();
	} else {
		document.addEventListener( 'DOMContentLoaded', fn );
	}
}

ready( function () {
	const maps = document.querySelectorAll( '.wp-block-cnt-syndicate-map' );
	for ( const map of maps ) {
		const zoom = parseInt( map.dataset.zoom, 10 );
		render(
			createElement( SyndicateMap, { zoom, scrollWheelZoom: false } ),
			map
		);
	}
} );
